import type { DailyChallengeConfig, PlayerProgress } from '../games/nganya/types';
import styles from './MainMenu.module.css';

interface Props {
  progress: PlayerProgress;
  daily: DailyChallengeConfig;
  onPlay: () => void;
  onDaily: () => void;
  onGarage: () => void;
  onHowTo: () => void;
  onToggleSound: () => void;
}

export function MainMenu({
  progress,
  daily,
  onPlay,
  onDaily,
  onGarage,
  onHowTo,
  onToggleSound,
}: Props) {
  return (
    <div className={styles.menu}>
      <section className={styles.hero} aria-label="Nganya">
        <picture className={styles.heroMedia}>
          <source
            media="(orientation: portrait) and (max-width: 520px)"
            srcSet="/assets/branding/nganya-hero-mobile.jpg"
          />
          <img
            src="/assets/branding/nganya-hero.jpg"
            alt="Colorful nganyas racing through the city"
            className={styles.heroImg}
            width={960}
            height={756}
            decoding="async"
            fetchPriority="high"
            draggable={false}
          />
        </picture>
        <div className={styles.heroShade} aria-hidden="true" />

        <div className={styles.heroTop}>
          <span className={styles.playhub}>PlayHub</span>
          <button
            type="button"
            className={`btn btn-ghost ${styles.soundBtn}`}
            onClick={onToggleSound}
            aria-label="Toggle sound"
          >
            {progress.soundEnabled ? '🔊' : '🔇'}
          </button>
        </div>

        <div className={styles.heroCopy}>
          <h1 className={`title ${styles.title}`}>Nganya</h1>
          <p className={styles.tagline}>Dodge traffic. Collect fares. Rule the road.</p>
        </div>
      </section>

      <div className={`stack ${styles.actions}`}>
        <button type="button" className="btn btn-primary" onClick={onPlay}>
          PLAY
        </button>
        <button type="button" className={`btn btn-ghost ${styles.daily}`} onClick={onDaily}>
          <div>
            <strong>Daily Challenge</strong>
            <small className="muted"> {daily.dateKey}</small>
          </div>
        </button>
        <div className="row">
          <button type="button" className="btn btn-ghost" style={{ flex: 1 }} onClick={onGarage}>
            Garage
          </button>
          <button type="button" className="btn btn-ghost" style={{ flex: 1 }} onClick={onHowTo}>
            How to Play
          </button>
        </div>
      </div>

      <footer className={styles.stats}>
        <div>
          <span className="muted">Best</span>
          <strong>{progress.bestScore}</strong>
        </div>
        <div>
          <span className="muted">Runs</span>
          <strong>{progress.totalRuns}</strong>
        </div>
        <div>
          <span className="muted">Fares</span>
          <strong>{progress.totalFares}</strong>
        </div>
      </footer>

      <a className={styles.back} href={import.meta.env.VITE_PLAYHUB_URL || 'https://playhub.co.ke'}>
        ← Back to PlayHub
      </a>
    </div>
  );
}
